import React, { useContext } from 'react';
import { useStaticQuery } from 'gatsby';
import { LanguageContext } from '../../providers';
import { findT } from '../../components/_helpers';
import Spacer from '../../components/structure/Spacer/Spacer';
import ContentConsentManager from '../../components/modules/ContentConsent/ContentConsentManager';

// TODO
import { jsx as ___EmotionJSX } from "@emotion/react";
const InfoBlock = _ref => {
  let {
    id
  } = _ref;
  const {
    language
  } = useContext(LanguageContext);
  const {
    directusLegal: legal,
    directusCompany: company
  } = useStaticQuery(query);
  if (legal || company) {
    const translations = legal && legal.translations.length > 0 ? findT(legal.translations, language) : null;
    switch (id) {
      case 'legal_authority':
        if (company.legal_authority) {
          return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
            dangerouslySetInnerHTML: {
              __html: company.legal_authority
            }
          }), ___EmotionJSX(Spacer, null));
        } else return null;
      case 'insurance':
        if (translations && translations.insurance) {
          return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h2", null, "Berufshaftpflichtversicherung"), ___EmotionJSX("div", {
            dangerouslySetInnerHTML: {
              __html: translations.insurance
            }
          }));
        } else return null;
      case 'image_sources':
        if (translations && translations.image_sources) {
          return ___EmotionJSX("div", {
            dangerouslySetInnerHTML: {
              __html: translations.image_sources
            }
          });
        } else return null;
      case 'additional_top_info':
        if (translations && translations.additional_top_info) {
          return ___EmotionJSX("div", {
            dangerouslySetInnerHTML: {
              __html: translations.additional_top_info
            }
          });
        } else {
          return null;
        }
      case 'additional_bottom_info':
        if (translations && translations.additional_bottom_info) {
          return ___EmotionJSX("div", {
            dangerouslySetInnerHTML: {
              __html: translations.additional_bottom_info
            }
          });
        } else {
          return null;
        }
      case 'data_protection':
        const dpc = legal ? legal.data_protection_commissioner[0] : null;
        if (dpc) {
          return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h3", null, "Gesetzlich vorgeschriebener Datenschutzbeauftragter"), ___EmotionJSX("p", null, "Wir haben f\xFCr unser Unternehmen einen Datenschutzbeauftragten bestellt."), ___EmotionJSX("b", null, dpc.name), ___EmotionJSX("p", null, dpc.street, " ", dpc.number, " ", ___EmotionJSX("br", null), dpc.city, " ", dpc.zip_code, " ", ___EmotionJSX("br", null)), ___EmotionJSX("p", null, "Telefon: ", dpc.phone_number, " ", ___EmotionJSX("br", null), "E-Mail: ", dpc.email, " ", ___EmotionJSX("br", null)));
        } else {
          return null;
        }
      case 'rolex':
        if (legal && legal.rolex_area) {
          return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h3", {
            id: "rolex-bereich"
          }, "Rolex Bereich"), ___EmotionJSX("p", null, "Wenn Sie den Rolex Bereich unserer Website besuchen, interagieren Sie mit einer eingebetteten Website von", ___EmotionJSX("a", {
            href: "https://www.rolex.com",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "www.rolex.com"), ". In diesem Fall gelten einzig die ", ___EmotionJSX("a", {
            href: "https://www.rolex.com/de/legal-notices/terms-of-use.html",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Nutzungsbedingungen"), ", ", ___EmotionJSX("a", {
            href: "https://www.rolex.com/de/legal-notices/privacy-notice.html",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Datenschutzhinweise"), " und ", ___EmotionJSX("a", {
            href: "https://www.rolex.com/de/legal-notices/cookies.html",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Cookie-Richtlinie"), " von  ", ___EmotionJSX("a", {
            href: "https://www.rolex.com",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "www.rolex.com"), "."), ___EmotionJSX("p", null, "Cookie-Richtlinien von Rolex: ", ___EmotionJSX("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://www.rolex.com/legal-notices/cookies.html"
          }, "https://www.rolex.com/legal-notices/cookies.html"), " Datenschutzhinweise von Adobe Analytics: ", ___EmotionJSX("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://www.adobe.com/de/privacy/policy.html"
          }, "https://www.adobe.com/de/privacy/policy.html"), " Datenschutzhinweise von Content Square: ", ___EmotionJSX("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://contentsquare.com/de-de/privacy-center/"
          }, "https://contentsquare.com/de-de/privacy-center/")));
        } else {
          return null;
        }
      case 'consentmanager':
        return ___EmotionJSX(ContentConsentManager, null);
      default:
        return null;
    }
  } else return null;
};
export default InfoBlock;
const query = "1515201620";